import { View, StyleSheet } from 'react-native';
import { Text, Button, Surface } from 'react-native-paper';
import { useRouter } from 'expo-router';
import { useTranslation } from 'react-i18next';
import BaseContainer from '@/components/BaseContainer';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import { Color } from '@/GlobalStyles';

export default function ErrorAccessScreen() {
  const router = useRouter();
  const { t } = useTranslation();

  return (
    <BaseContainer>
      <View style={styles.container}>
        <Surface style={styles.surface} elevation={2}>
          <View style={[styles.iconContainer, { backgroundColor: '#ff5252' + '20' }]}>
            <Icon name="lock-alert" size={48} color="#ff5252" />
          </View>
          <Text style={styles.title}>{t('patient.error')}</Text>
          <Text style={styles.message}>
            Accès non autorisé. Veuillez utiliser le lien fourni par votre chirurgien pour accéder au formulaire.
          </Text>
          <Button
            mode="contained"
            onPress={() => router.replace('/')}
            buttonColor={Color.MainBleu}
            style={styles.button}
          >
            Retour à l'accueil
          </Button>
        </Surface>
      </View>
    </BaseContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  surface: {
    padding: 32,
    borderRadius: 12,
    backgroundColor: 'white',
    alignItems: 'center',
    width: '100%',
    maxWidth: 400,
  },
  iconContainer: {
    width: 80,
    height: 80,
    borderRadius: 40,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 20,
  },
  title: {
    fontSize: 24,
    fontWeight: '600',
    marginBottom: 16,
    color: Color.MainNoir,
  },
  message: {
    fontSize: 16,
    color: Color.MainGris,
    textAlign: 'center',
    marginBottom: 24,
    lineHeight: 24,
  },
  button: {
    width: '100%',
  },
});
